import Transaction from '@js/store/modules/transaction';
import PriceOverride from '@js/store/modules/price-override';

export default {
    created() {
        if (!this.$store.hasModule('transaction')) {
            this.$store.registerModule('transaction', Transaction);
        }

        if (!this.$store.hasModule('priceOverride')) {
            this.$store.registerModule('priceOverride', PriceOverride);
        }
    },
};
